import 'tslib';
import 'long';
import '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import * as JSONLong from 'json-long';
import 'moize';
import { Message } from '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class RtcCommandMessage extends Message {
    constructor() {
        super(...arguments);
        // RTC 控制信令类型
        this.commandType = 1;
    }
    static fillRtcParam(target) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (target.content !== '') {
            const contentObj = JSONLong.parse(target.content); // 里面可能带了数字
            target.commandType = contentObj.command_type;
            target.channelId = contentObj.channel_id;
            target.deviceId = contentObj.device_id;
            target.userId = (_a = contentObj.user_id) === null || _a === void 0 ? void 0 : _a.toString();
            target.voipStatus = contentObj.voip_status;
            target.voipType = contentObj.voip_type;
            target.conversationShortId = (_b = contentObj.conversation_short_id) === null || _b === void 0 ? void 0 : _b.toString();
            target.callerId = (_c = contentObj.caller_id) === null || _c === void 0 ? void 0 : _c.toString();
            target.chatDuration = (_d = contentObj.chat_duration) === null || _d === void 0 ? void 0 : _d.toString();
            target.refChannelId = (_e = contentObj.ref_channel_id) === null || _e === void 0 ? void 0 : _e.toString();
            target.mode = contentObj.mode;
            target.userNum = contentObj.user_num ? Number.parseInt((_f = contentObj.user_num) === null || _f === void 0 ? void 0 : _f.toString(), 10) : 0; // 取不到这个值设置成0
            target.conversationId = contentObj.con_id;
            target.callees = (_g = contentObj.callees) === null || _g === void 0 ? void 0 : _g.map(m => m.toString());
        }
    }
}

export { RtcCommandMessage };
//# sourceMappingURL=RtcMessage.js.map
